module.exports = "https://cdn.hellotech.com/client-assets/tech-client-speaker-desktop_6def6e987f29046aa83fbb4a219f92c1.jpg";